import { mapActions, mapGetters, mapState } from 'vuex';
import researchWidget from '@/components/research-widget/research-widget.vue';
import twitterTimeline from '@/components/twitter/twitter-timeline/twitter-timeline.vue';
import insightWidget from '@/components/insight/insight-widget/insight-widget.vue';
import marketBiggestGains from '@/components/market/market-biggest-gains/market-biggest-gains.vue';
import marketMoneyWidget from '@/components/market/market-money-widget/market-money-widget.vue';
import marketCurrentlyPredicting from '@/components/market/market-currently-predicting/market-currently-predicting.vue';
import marketKeyStats from '@/components/market/market-key-stats/market-key-stats.vue';
import marketTopComments from '@/components/market/market-top-comments/market-top-comments.vue';
import insightNews from '@/components/insight/insight-news/insight-news.vue';
import { MODALS } from '@/components/app/app-modals/app-modals';
import contentLoaderMixin from '@/mixins/contentLoader';
import electionMap from '@/components/pages/page-election-map-new/election-map/election-map.vue';
import dailyMarkets from '@/components/daily-markets/daily-markets.vue';
import pageMarkets from '@/components/pages/page-markets/page-markets.vue';
import newsFeed from './news-feed/news-feed.vue';
import inTheNews from './in-the-news/in-the-news.vue';
import podcasts from './podcasts/podcasts.vue';
import heroUnitSlider from './hero-unit-slider/hero-unit-slider.vue';
import quotes from './quotes/quotes.vue';
import howItWorks from './how-it-works/how-it-works.vue';
import mostPredicted from './most-predicted/most-predicted.vue';
import mostPredictedList from './most-predicted-list/most-predicted-list.vue';
import homeVideos from './home-videos';


export default {
  mixins: [
    contentLoaderMixin,
  ],
  components: {
    electionMap,
    heroUnitSlider,
    quotes,
    howItWorks,
    mostPredicted,
    podcasts,
    researchWidget,
    inTheNews,
    twitterTimeline,
    newsFeed,
    mostPredictedList,
    insightWidget,
    marketBiggestGains,
    marketMoneyWidget,
    marketCurrentlyPredicting,
    marketKeyStats,
    marketTopComments,
    homeVideos,
    insightNews,
    dailyMarkets,
    pageMarkets
  },
  metaInfo() {
    return {
      title: 'PredictIt',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile', 'isShutdownModeOn']),
    ...mapGetters('user', ['isUserRestricted', 'isLoggedIn']),
    ...mapState('popup', ['currentPopup']),
    classModifiers() {
      return {
        'home-old': true,
        'home-old--shutdown': this.isShutdownModeOn,
      };
    },
    showMap() {
      return process.env.SHOW_MAP_ON_HOMEPAGE;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
  },
  mounted() {
    if (this.isUserRestricted && !this.currentPopup) {
      this.setCurrentPopup(MODALS.LOGIN);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/home/home-old/home-old.js